<template>
  <div class="w-full md:w-5/6 absolute bg-white pt-2" style="bottom: -40px;">
    <div class="w-full items-center md:items-end flex flex-col md:flex-row relative h-full md:h-16  via-white space-x-0 md:space-x-2 space-y-2 md:space-y-0">
      <button
        v-on:click="confirmPostSending"
        :disabled="disableConfirm"
        class="w-full md:w-6/12  h-10  btext-white font-medium rounded-md "
        :class="
          loading || disableConfirm
            ? 'bg-platinumFire text-customGrayDark cursor-default'
            : 'bg-aquamarine'
        "
      >
        <div
          @mouseover="overButton(true, 'confirm')"
          @mouseleave="overButton(false, 'confirm')"
        >
          <span
            class=" font-light"
            :class="loading || disable ? 'text-cosmosFire cursor-default' : 'text-white'"
            >Confirm post {{ newDate !== '' ? `for ${newDate}` : '' }}</span
          >
        </div>
      </button>

      <button
        v-on:click="$emit('submitPostNow')"
        :disabled="loading || disable"
        class="w-full md:w-3/12 h-10  text-white font-medium rounded-md"
        :class="
          disable
            ? 'bg-platinumFire text-customGrayDark cursor-default'
            : 'bg-aquamarine'
        "
      >
        <div
          @mouseover="overButton(true, 'now')"
          @mouseleave="overButton(false, 'now')"
        >
          <span
            class=" font-light"
            :class="loading || disable ? 'text-cosmosFire cursor-default' : 'text-white'"
            >Post Now</span
          >
        </div>
      </button>

      <button
        v-on:click="$emit('submitSaveAsDraft')"
        :disabled="loading || disable"
        class="w-full md:w-3/12 h-10 text-payne text-sm font-medium rounded-md bg-white hover:bg-payne hover:text-white transition-all"
      >
        <div
          @mouseover="overButton(true, 'draft')"
          @mouseleave="overButton(false, 'draft')"
        >
          <span class=" font-light">Save Draft</span>
        </div>
      </button>
    </div>

  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template';

export default {
  name: "SubmitButtons",

  components: {
    VueLoading
  },

  props: {
    disable: {
      type: Boolean,
      require: true
    },

    disableConfirm: {
      type: Boolean,
      require: true
    },

    loading: {
      type: Boolean,
      default: false
    },

    newDate: {
      type: String,
      default: ''
    }
  },

  methods: {
    confirmPostSending() {
      this.$emit('submitPost');
    },

    overButton(isEnabled, button) {
      this.$emit('mouseover', {enabled: isEnabled, button: button});
    }
  },
};
</script>
